var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.language === 'pt_br')?_c('privacy-policy-pt-br'):(_vm.$store.state.language === 'es')?_c('privacy-policy-es'):(_vm.$store.state.language === 'it')?_c('privacy-policy-it'):_c('privacy-policy-en')}
var staticRenderFns = []

export { render, staticRenderFns }